import { OnChangeOrOnBlurType } from '../types/global';
import { parseInlineMarkdown } from '@/util/parseInlineMarkdown';
import { Input, Textarea } from './ui/input';

export interface ResponseTextFieldProps {
  value?: string;
  label: string;
  multiline?: boolean;
  alwaysShowLabel?: boolean;
  error?: boolean;
  onBlur?: () => void;
}

export const ResponseTextField = ({
  value,
  label,
  multiline,
  onChange,
  alwaysShowLabel,
  error,
  onBlur,
}: ResponseTextFieldProps & OnChangeOrOnBlurType<string>) => {
  return (
    <div className="flex flex-col gap-1 w-full">
      {alwaysShowLabel && (
        <p className="text-sm font-medium text-indigo-900">
          {parseInlineMarkdown(label)}
        </p>
      )}
      {multiline ? (
        <Textarea
          placeholder={label}
          value={value}
          onChange={onChange ? (e) => onChange(e.target.value) : undefined}
          onBlur={onBlur}
          aria-invalid={error}
        />
      ) : (
        <Input
          placeholder={label}
          value={value}
          onChange={onChange ? (e) => onChange(e.target.value) : undefined}
          onBlur={onBlur}
          aria-invalid={error}
        />
      )}
    </div>
  );
};
